<template>
  <div class="footer__sub">
    <div class="container-fluid">
      <div>
        <nav>
          <ul>
            <li
                v-for="menuItem in items"
                :key="`mifs-${menuItem.id}`"
            >
              <button
                  v-if="menuItem.url === '#cookie-einstellungen'"
                  v-html="menuItem.title"
                  @click="openUC"
              ></button>
              <IoRouterLink
                  v-else
                  :link-url="menuItem.url"
                  :link-target="menuItem.target"
                  :link-title="menuItem.titleAttr"
                  :id="`iomi-${ menuItem.id }`"
                  :active="menuItem.active"
              >
                  <span
                      v-html="menuItem.title"
                  ></span>
              </IoRouterLink>
            </li>
            <li>
              <a href="#" onclick="UC_UI.showSecondLayer();">Einwilligungsmanagement</a>
            </li>
          </ul>
        </nav>
      </div>
      <div>
        &copy; {{ currentYear }} Stadtwerke Ahrensburg GmbH
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MenuInterface from '@/interfaces/MenuInterface';
import AppDate from '../../classes/AppDate';

defineProps<{
  items: MenuInterface[]
}>();

const currentYear = new AppDate().format('Y');

const openUC = (): void => {
  if (window.UC_UI) {
    window.UC_UI.showSecondLayer();
  }
};
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.footer__sub {
  @include font-small;
  padding: 1.35em 0;
  background-color: #FFFFFF;

  @media (max-width: map_get($grid-breakpoints, 'sm')) {
    padding: 0.938rem 0 0 0;

    .spacer {
      display: none;
    }
    .sab {
      margin-top: 0.875rem;
    }
  }

  .container-fluid {
    display: grid;
    grid-auto-flow: dense;
    grid-auto-rows: auto;
    grid-template-columns: 1fr;
    justify-content: center;
    gap: 1.875rem;
    text-align: center;

    @media (min-width: 1080px) {
      grid-template-columns: 1fr auto;
      align-items: center;

      > div:nth-child(1) {
        grid-column: 2 / 3;
        text-align: end;
      }

      > div:nth-child(2) {
        grid-column: 1 / 2;
        text-align: start;
      }
    }
  }

  nav {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: block;

      li {
        @include font-small;;
        display: block;
        position: relative;
        padding: .25em 1.5em;
        line-height: 1.2;
        text-align: center;

        a, button {
          font-size: inherit;
          padding: 0;
          text-decoration: none;
          color: $body-color;
          border: 0;
          background: transparent;
          outline: 0;
        }

        @media (max-width: map_get($grid-breakpoints, 'md')) {
          line-height: 2rem;
          padding: 0;
        }

        @media (min-width: map_get($grid-breakpoints, 'md')) {
          padding: 0 1em;
          display: inline-block;

          &:after {
            content: '';
            display: block;
            height: 1em;
            width: 1px;
            background-color: $body-color;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }

          &:first-child {
            padding-left: 0;
          }

          &:last-child {
            padding-right: 0;

            &:after {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
